import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { parse } from 'query-string';
import { handleErrors, HTTP_CODE } from '../../utils/redirector-utils';

export function getPIPRules({ path, itemId, queryParams = '', response, batchDomains = false, disablePEPRedirect }) {
  const params = parse(queryParams);
  let shouldRedirect = false;
  let httpCode = HTTP_CODE.OK;
  let redirectPath;
  let data;
  let loading;
  let error;

  if (!/^\d{8,10}$/.test(itemId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND
    };
  }
  if (response) {
    ({ data, error, loading } = response);
  } else {

    ({
      data,
      error,
      loading
    } = useProductDeprecated({
      itemId,
      skip: !!response,
      domains: ['identifiers'],
      batchDomains,
      ssr: true
    }));
  }

  if (!data && loading) return { loading };

  const errors = handleErrors(error);

  if (errors) {
    return errors;
  }

  if ((itemId && !data?.product) || (!data && !error && !itemId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND
    };
  }

  const { canonicalUrl } = data.product?.identifiers || {};

  let normalizedPath = path;
  let isReviewsPage;
  if (path.startsWith('/p/reviews/')) {
    isReviewsPage = true;
    normalizedPath = path.replace('/reviews', '');
  }

  if (normalizedPath !== canonicalUrl) {
    shouldRedirect = true;
    httpCode = HTTP_CODE.PERM_REDIRECT;
    redirectPath = isReviewsPage ? canonicalUrl.replace('/p/', '/p/reviews/') : canonicalUrl;
  }

  // only redirect pips to pep, not pep to pep
  if (!disablePEPRedirect && params.cm_mmc && /^\/p\//.test(normalizedPath)) {
    let cmmmc = '';
    if (typeof params.cm_mmc === 'string') {
      cmmmc = params.cm_mmc;
    } else if (Array.isArray(params.cm_mmc) && params.cm_mmc.length) {
      cmmmc = params.cm_mmc[0];
    }
    if (/^Shopping/i.test(cmmmc)) {
      shouldRedirect = true;
      httpCode = HTTP_CODE.TEMP_REDIRECT;
      redirectPath = canonicalUrl.replace('/p/', '/pep/');
    }
  }

  return {
    shouldRedirect,
    redirectPath,
    httpCode
  };
}


export const usePIPRedirectRules = (props) => {
  return getPIPRules({ ...props, batchDomains: true });
};
